import Action from "./Action";
import Cutout from "../Main/Cutout";
import WmsProjection from "../Projection/WmsProjection";
import {Serialization} from "../Main/Serializer";

export default class ChangeCutoutEraseDrawnGridAction implements Action {

    private readonly oldEraseDrawnGrid: boolean|null;

    constructor(private cutout: Cutout<any, any, any>, private newEraseDrawnGrid: boolean|null) {
        const projection = this.cutout.getProjection();
        if(!(projection instanceof WmsProjection)) {
            throw new Error('Can only change EraseDrawnGrid for WMS projection');
        }
        this.oldEraseDrawnGrid = projection.getEraseDrawnGrid();
    }

    public apply() {
        const projection = this.cutout.getProjection();
        if(!(projection instanceof WmsProjection)) {
            throw new Error('Can only set EraseDrawnGrid for WMS projection');
        }
        projection.setEraseDrawnGrid(this.newEraseDrawnGrid);
    }

    public revert() {
        const projection = this.cutout.getProjection();
        if(!(projection instanceof WmsProjection)) {
            throw new Error('Can only set EraseDrawnGrid for WMS projection');
        }
        projection.setEraseDrawnGrid(this.oldEraseDrawnGrid);
    }

    public merge(newAction: Action): boolean {
        return false;
    }

    public serializeForDebug(): Serialization {
        return {
            cutout: this.cutout.id,
            oldEraseDrawnGrid: this.oldEraseDrawnGrid,
            newEraseDrawnGrid: this.newEraseDrawnGrid,
        };
    }
}
